import React, { Fragment } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { NotificationMessageBlock } from '@notifications/components/NotificationMessageBlock';
import { IPortalSessionNotes } from './interfaces';

export const PortalSessionNotes: React.FC<IPortalSessionNotes> = ({
  notes,
  labelKey = 'competitions:portal.details.sessionsTab.notes.label',
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <NotificationMessageBlock>
      <Fragment>
        <Box component="span" sx={{ fontWeight: 'bold' }}>
          {t(labelKey)}
        </Box>
        {' '}
        {notes}
      </Fragment>
    </NotificationMessageBlock>
  );
};
